module.exports = __webpack_public_path__ + "img/230.a41098bc.jpg";